import { parseISO, isBefore } from "date-fns";

const startDateTimeBeforeEndDateTime = (startDateTime: string | number | Date, endDateTime: string | number | Date) => {
  let start;
  let end;

  if (typeof startDateTime === 'string') {
    start = parseISO(startDateTime);
  } else {
    start = startDateTime;
  }

  if (typeof endDateTime === 'string') {
    end = parseISO(endDateTime);
  } else {
    end = endDateTime;
  }

  return isBefore(start, end);
};

export default startDateTimeBeforeEndDateTime;
